import { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";

import { PencilIcon } from "@heroicons/react/24/outline";

import { Alert } from "../../components/base/Alert";
import { Button } from "../../components/base/Button";
import { errorResolver } from "../../utils/errorResolver";
import LoadingWheel from "../../components/shared/LoadingWheel";
import useApplication from "../../data/Application/useApplication";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { ApplicationDetails } from "../../components/ViewApplication/ApplicationDetails";

export function ViewApplication() {
  const { applicationId } = useParams();
  const { application } = useApplication(applicationId!);
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    if (!application.isLoading && application.data) {
      setInfo({
        name: application.data.name,
        desc: `View ${application.data.name} application`,
        pageTitle: `View Application | ${application.data.name}`,
      });
    } else {
      setInfo({
        name: "View Application",
        desc: "View application details",
        pageTitle: "View Application",
      });
    }
  }, [application.isLoading, application.data]);

  if (!applicationId) {
    return <Navigate to="/applications" />;
  } else if (application.isLoading) {
    return (
      <div className="flex justify-center py-10">
        <LoadingWheel />
      </div>
    );
  } else if (application.isError || !application.data) {
    return (
      <Alert
        severity="error"
        title="Error getting customer"
        message={errorResolver(application.error)}
      />
    );
  } else {
    return (
      <>
        <div className="mb-6 flex justify-between">
          <Link to={`/application/edit/${applicationId}`}>
            <Button className="flex items-center space-x-2">
              <PencilIcon className="h-5 w-5 -ml-1" />
              <p>Edit Application</p>
            </Button>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <ApplicationDetails application={application.data} />
        </div>
      </>
    );
  }
}
